import { render, staticRenderFns } from "./TemplateCardV2.vue?vue&type=template&id=2327c3ca&scoped=true&"
import script from "./TemplateCardV2.vue?vue&type=script&lang=js&"
export * from "./TemplateCardV2.vue?vue&type=script&lang=js&"
import style0 from "./TemplateCardV2.vue?vue&type=style&index=0&id=2327c3ca&prod&lang=scss&scoped=true&"
import style1 from "./TemplateCardV2.vue?vue&type=style&index=1&id=2327c3ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2327c3ca",
  null
  
)

export default component.exports